define(function(require, exports, module) {
    'use strict';
    const user = require('user');
    const MenuView = require('modules/menu/menu.view');
    const core = require('core');
    const $ = require('j');
    const { dispatcher } = require('bundle');

    module.exports = MenuView.extend({

        subscribe: function() {
            MenuView.prototype.subscribe.apply(this, arguments);

            dispatcher.listen('menu:items', this.render.bind(this));
        },

        handleLinkNavigate: function(event) {
            const target = event.target;
            const li = target.closest('.fn-play-bingo');

            if (li) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                const link = li.querySelector('a');
                const url = link.getAttribute('href');

                this._launchBingo(url);

                return;
            }

            return MenuView.prototype.handleLinkNavigate.apply(this, arguments);
        },

        _launchBingo: function handler(url) {
            if (!Playtech.API.auth.isLoggedIn) {
                Playtech.API.popup.showPopup('login', {
                    onLogin: () => handler(url)
                });
                return;
            }

            if (Playtech.API.device.isDesktop) {
                const win = window.open('about:blank', '_blank', 'popup,width=1024,height=768');

                Playtech.API.auth.getTemporaryAuthenticationToken().then((token) => {
                    const { username, currency } = Playtech.fetchUserDetails();

                    win.location.href = `${url}&token=${username}:${token}&currency=${currency}`;
                });
            } else {
                Playtech.API.auth.getTemporaryAuthenticationToken().then((token) => {
                    const { username, currency } = Playtech.fetchUserDetails();

                    location.href = `${url}&token=${username}:${token}&currency=${currency}`;
                });
            }
        },

        toggleSecondlevelMenu: function(pageUrl) {
            var parentItem = this.model.getCurrentParentItem(pageUrl);
            if (!parentItem) {
                this.$('.fn-secondlevel-wrapper, .fn-secondlevel').addClass('hidden');

                return;
            }

            var parentUrl = parentItem.friendlyURL;
            var $menu = this.$('[data-parent-url="' + parentUrl + '"]');
            var isVisible = Boolean($menu.length > 0 && $menu[0].children.length > 0);

            this.$('.fn-secondlevel-wrapper').toggleClass('hidden', !isVisible);
            this.$('.fn-secondlevel').addClass('hidden');

            $('.fn-secondlevel-wrapper.hidden').length
                ? $('.header').removeClass('header-with-secondlevel')
                : $('.header').addClass('header-with-secondlevel');

            isVisible && $menu.removeClass('hidden');

            core.trigger('menu:secondLevel:toggle');
        },

        _renderSideMenu: function() {
            this.$el.html(
                this.tmpl('side.menu', {
                    menuItems: this.menuItems,
                    isUserLogged: user.isLoggedIn(),
                    userName: user.get('userName')
                }).replace()
            );

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        }
    });
});
